// src/App.js
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { IHistory } from '../../../interfaces'; 
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getChatbotAnswers } from '../../../services/chatbotService'
export interface IChatBotProps {
    firstName: string;
}
export interface IChatBotState {
    messages: any;
    input: any;
    open: boolean;
    isLoading: boolean;
}
export class ChatBotImpl extends React.Component<IChatBotProps, IChatBotState> {
    constructor(props: IChatBotProps | Readonly<IChatBotProps>) {
        super(props);
        this.state = { input: "", messages: [], open: false, isLoading: false };
    }
    getAnswers = async () => { 

        /* window.scrollTo({
            top: document.getElementById("chat-bot-body")?.scrollHeight,
            behavior: "smooth"   // smooth scroll
        }); */
        const contentDiv = document.getElementById('chatbotBody');

        if(contentDiv) {
            //contentDiv.scrollTop = contentDiv.scrollHeight;  
            contentDiv.scrollIntoView({ behavior: 'smooth', block: 'end' }); 
            contentDiv.scrollTop = contentDiv.scrollHeight;

        }
        let question = this.state.input;
        this.setState({isLoading: true, input: '',});
        let answer = await getChatbotAnswers(question);
        console.log(answer)
        //let resText = answer['ResultItems'][0]['DocumentExcerpt']['Text'] || 'No result found..';
        let resText = answer && answer['ResultItems'].length>0? ( ( answer['ResultItems'][0]['AdditionalAttributes'].length>0 && answer['ResultItems'][0]['AdditionalAttributes'][0]['Value']['TextWithHighlightsValue']['Text'] ) || ( answer['ResultItems'][0]['DocumentExcerpt']['Text']) || 'No result found..') : 'No result found..';
        /* if(answer) {
            resText = answer?answer.description +': ' +answer.extract:'';
        } else {
            resText = 'No result found'
        } */
        const botMsg = { sender: "bot", text: resText };
        this.setState({ messages: [...this.state.messages, botMsg],  isLoading: false }); 
    }
    
    render_TEMP() {
        /* const [messages, setMessages] = useState([{}]);
        const [input, setInput] = useState("");
        const [open, setOpen] = useState(false); */ // toggle chat
        const {input, messages, open, isLoading} = this.state;
        const sendMessage = () => {
            if (!input) return;

            const userMsg: any = { sender: "user", text: input };
            this.setState({
                messages: [...this.state.messages, userMsg]
            });  

            // fake bot reply
            const botMsg = { sender: "bot", text: "You said: " + input };
            /* setTimeout(() => { 
                this.setState({ messages: [...this.state.messages, botMsg] }); 
            }, 500); 
            this.setState({input: ''});  */
            this.getAnswers();
        };

        return <div className="chatBot" /* style={{width: '500px', height: '500px'}} */> 
            {!open && (
                <Button 
                className=" unopen-icon rounded-circle"
                onClick={() => this.setState({open: true})  }
                >
                💬
                </Button>
            )}
 
            {open && ( 

                <div
                className="card chat-box position-fixed bottom-0 end-0 m-3 shadow"
                style={{ width: "600px", height: "505px" }}
                >
               {/*  <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white"> 
                    <Button
                    variant="light"
                    size="sm"
                    onClick={() => this.setState({open: false}) }
                    >
                    ⬇
                    </Button>
                </div> */}
                    <Button variant="light" size="sm" onClick={() => this.setState({open: false}) } className="chat-bot-close" > ⬇
                    </Button>
                    <iframe src="https://copilotstudio.microsoft.com/environments/Default-8f0fa409-0926-4e9d-a365-983fb317f708/bots/cr0d7_safeConnect/webchat?__version__=2" frameBorder="0" style={{width:"100%", height:"100%"}}></iframe>
                    <div id="webchat" role="main"></div>
                </div>
            )}
        </div>
        return (
            <div className="chatBot">
            {/* Floating button when minimized */}
            {!open && (
                <Button
                /* className="position-fixed unopen-icon bottom-0 end-0 m-3 rounded-circle" */
                className=" unopen-icon rounded-circle"
                onClick={() => this.setState({open: true})  }
                >
                💬
                </Button>
            )}

            {/* Chat window */}
            {open && (
                <div
                className="card chat-box position-fixed bottom-0 end-0 m-3 shadow"
                style={{ width: "600px", height: "505px" }}
                >
                <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
                    <span className="chat-box-title">Chatbot</span>
                    <Button
                    variant="light"
                    size="sm"
                    onClick={() => this.setState({open: false}) }
                    >
                    ⬇
                    </Button>
                </div>

                <div className="card-body overflow-auto" id="chatbotBody" style={{ background: "#f8f9fa" }}>
                    {messages.map((msg: any, i: any) => (
                        <div
                            key={i}
                            className={` ${
                            msg.sender === "user"
                                ? "user-text"
                                : "bot-text"
                            }`}
                        > 
                            {msg.sender === "user" &&  <span className="avatharText">{this.props.firstName[0]}</span>}
                            <p>{msg.text} </p>
                        </div>
                    
                    ))}
                    {isLoading && <div className="loadering"></div>}
                </div>

                <div className="card-footer d-flex">
                    <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Type a message..."
                    value={input}
                    onChange={(e) =>  this.setState({input: e.target.value}) }
                    onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                    />
                    <Button onClick={sendMessage}>Send</Button>
                </div>
                </div>
            )}
            </div>
        );
    }
     render() {
        /* const [messages, setMessages] = useState([{}]);
        const [input, setInput] = useState("");
        const [open, setOpen] = useState(false); */ // toggle chat
        const {input, messages, open, isLoading} = this.state;
        const sendMessage = () => {
            if (!input) return;

            const userMsg: any = { sender: "user", text: input };
            this.setState({
                messages: [...this.state.messages, userMsg]
            });  

            // fake bot reply
            const botMsg = { sender: "bot", text: "You said: " + input };
            /* setTimeout(() => { 
                this.setState({ messages: [...this.state.messages, botMsg] }); 
            }, 500); 
            this.setState({input: ''});  */
            this.getAnswers();
        }; 
         
        return (
            <div className="chatBot">
            {/* Floating button when minimized */}
            {!open && (
                <Button
                /* className="position-fixed unopen-icon bottom-0 end-0 m-3 rounded-circle" */
                className=" unopen-icon rounded-circle"
                onClick={() => this.setState({open: true})  }
                >
                💬
                </Button>
            )}

            {/* Chat window */}
            {open && (
                <div
                className="card chat-box position-fixed bottom-0 end-0 m-3 shadow"
                style={{ width: "600px", height: "505px" }}
                >
                <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
                    <span className="chat-box-title">Chatbot</span>
                    <Button
                    variant="light"
                    size="sm"
                    onClick={() => this.setState({open: false}) }
                    >
                    ⬇
                    </Button>
                </div>

                <div className="card-body overflow-auto" id="chatbotBody" style={{ background: "#f8f9fa" }}>
                    {messages.map((msg: any, i: any) => (
                        <div
                            key={i}
                            className={` ${
                            msg.sender === "user"
                                ? "user-text"
                                : "bot-text"
                            }`}
                        > 
                            {msg.sender === "user" &&  <span className="avatharText">{this.props.firstName[0]}</span>}
                            <p>{msg.text} </p>
                        </div>
                    
                    ))}
                    {isLoading && <div className="loadering"></div>}
                </div>

                <div className="card-footer d-flex">
                    <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Type a message..."
                    value={input}
                    onChange={(e) =>  this.setState({input: e.target.value}) }
                    onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                    />
                    <Button onClick={sendMessage}>Send</Button>
                </div>
                </div>
            )}
            </div>
        );
    }
}

export function mapStateToProps(state: any) { 
    const firstName = state.login.get('firstName');  
    return {
        firstName
    };
}

export const ChatBot = withRouter(connect<IChatBotProps, any, any>(mapStateToProps)(ChatBotImpl));

